import { observer } from 'mobx-react-lite';
import { FeedbackService } from '~/service/service.feedback';
import { useService } from '~/shared/service/service.base';
import { Col } from '../view.box';
import { FeedbackDrawerItem, FeedbackDrawerTitle, FeedbackDrawerValue } from './feedback.drawer';

export const FeedbackDrawerDetails = observer(() => {
	const [{ selectedItem }] = useService(FeedbackService);

	return (
		<Col gap={1}>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Status:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>{selectedItem?.status}</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Message:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>{selectedItem?.message}</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			{selectedItem?.statusChangedBy && (
				<>
					<FeedbackDrawerItem>
						<FeedbackDrawerTitle>Status changed by:</FeedbackDrawerTitle>
						<FeedbackDrawerValue>{selectedItem?.statusChangedBy}</FeedbackDrawerValue>
					</FeedbackDrawerItem>
					<FeedbackDrawerItem>
						<FeedbackDrawerTitle>Status changed at:</FeedbackDrawerTitle>
						<FeedbackDrawerValue>
							{new Date(selectedItem?.statusChangedAt ?? 0).toLocaleString()}
						</FeedbackDrawerValue>
					</FeedbackDrawerItem>
				</>
			)}
		</Col>
	);
});
